document.addEventListener("DOMContentLoaded", () => {

  const applyGlass = (btn) => {
    if (!btn) return;

    btn.removeAttribute("style");

    btn.style.background = "rgba(255, 255, 255, 0.25)";
    btn.style.backdropFilter = "blur(3px) saturate(180%)";
    btn.style.webkitBackdropFilter = "blur(3px) saturate(180%)";
    btn.style.border = "1px solid rgba(255, 255, 255, 0.3)";
    btn.style.boxShadow =
      "0 8px 32px rgba(31, 38, 135, 0.2), inset 0 0 5px rgba(255, 255, 255, 0.75)";

    const icon = btn.querySelector("svg");
    if (icon) icon.style.filter = "drop-shadow(0 1px 2px rgba(0,0,0,0.3))";

    const textNode = btn.querySelector(".chat-title, span, p, div");
    if (textNode) {
      textNode.style.textShadow = "0 1px 2px rgba(0,0,0,0.3)";
      textNode.style.color = "white";
    }

    const badge = btn.querySelector('[data-spec="notification-badge"]');
    if (badge) {
      badge.style.filter = "drop-shadow(0 2px 4px rgba(0,0,0,0.3))";
    }

    const childObserver = new MutationObserver(() => {
      const icon = btn.querySelector("svg");
      if (icon) {
        icon.style.filter = "drop-shadow(0 1px 2px rgba(0,0,0,0.3))";
      }

      const textNode = btn.querySelector(".chat-title, span, p, div");
      if (textNode) {
        textNode.style.textShadow = "0 1px 2px rgba(0,0,0,0.3)";
        textNode.style.color = "white";
      }

      const badge = btn.querySelector('[data-spec="notification-badge"]');
      if (badge) {
        badge.style.filter = "drop-shadow(0 2px 4px rgba(0,0,0,0.45))";
      }
    });

    childObserver.observe(btn, {
      subtree: true,
      childList: true
    });
  };

  const interval = setInterval(() => {
    const inbox = document.querySelector("inbox-online-store-chat");
    if (!inbox || !inbox.shadowRoot) return;

    const shadow = inbox.shadowRoot;

    let btn = shadow.querySelector("button.chat-toggle");
    applyGlass(btn);

    const observer = new MutationObserver(() => {
      const newBtn = shadow.querySelector("button.chat-toggle");

      if (newBtn && newBtn !== btn) {
        btn = newBtn;
        applyGlass(btn);
      }

      if (newBtn && newBtn.style.background !== "rgba(255, 255, 255, 0.25)") {
        applyGlass(newBtn);
      }
    });

    observer.observe(shadow, {
      subtree: true,
      attributes: true,
      childList: true
    });

    clearInterval(interval);
  }, 300);

});
